module.exports = __webpack_public_path__ + "static/media/renta-garantizada.f7e7d7a7.png";